<template lang="html">
    <div>
        Edit Page
        <div v-if="isLoadingPage == false">

          <page-form  v-model="page" @change="pageFormChange($event)" />

          <!-- Buttons -->
          <v-container>
            <v-layout justify-space-between>

              <div>
                <v-btn color="error" large @click="clickDelete()">Apagar</v-btn>
              </div>

              <div>
                <v-btn color="" large @click="clickCancel()">Cancelar</v-btn>
                <v-btn color="success" :disabled="!isPageValid" large @click="clickSave()">Guardar</v-btn>
              </div>
            </v-layout>
          </v-container>

          <v-dialog
            v-model="showDeleteDialog"
            max-width="290"
          >
            <v-card>
              <v-card-title class="headline">Apagar página "{{page.title}}?"</v-card-title>

              <v-card-text>
                Atenção: Esta ação não é reversível.
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>

                <v-btn
                  color="green darken-1"
                  flat="flat"
                  @click="closeDeleteDialog"
                >
                  Cancelar
                </v-btn>

                <v-btn
                  color="green darken-1"
                  flat="flat"
                  @click="confirmDelete()"
                >
                  Continuar
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>

        <div v-else>
          A Carregar
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import pageForm from '@/components/Page/pageForm'
export default {
  created: function () {
    //if ew dont have a pageId on route params route to pageList
    if(!this.$route.params.pageId){
      this.$router.push({ name: 'PageList' })
    } else {
      this.isLoadingPage = true
      this.downloadPage({
        id: this.$route.params.pageId
      }).then(response => {
        this.page = response.data
        this.isLoadingPage = false
      })
    }
  },
  data: function () {
    return {
      isLoadingPage: false,
      showDeleteDialog: false,
      isPageValid: true,
    }
  },
  computed: {
    ...mapGetters([
      'getSelectedPage',
    ]),
    mainPageId: function () {
      return Number(this.page.id)
    },
    page: {
      get: function () {
        return this.getSelectedPage
      },
      set: function(newVal) {
        this.updateSelectedPage(newVal)
      }
    }
  },
  methods: {
    ...mapActions([
      'downloadPage',
      'savePage',
      'deletePage',
      'updateSelectedPage'
    ]),
    clickSave: function () {
      this.savePage({
        page:this.page
      }).then(() => {
        this.$router.push({ name: 'PageList' })
      })
    },
    clickCancel: function () {
      this.$router.push({ name: 'PageList' })
    },
    clickDelete: function () {
      this.showDeleteDialog = true
    },
    closeDeleteDialog: function () {
      this.showDeleteDialog = false
    },
    confirmDelete: function () {
      this.deletePage(this.mainPageId).then(() =>{
        this.closeDeleteDialog()
        this.$router.push({ name: 'PageList' })
      })
    },
    pageFormChange: function ($event) {
      this.isPageValid = $event.valid
    }
  },
  components:{
    pageForm
  }
}
</script>

<style lang="css" scoped>
</style>
